export default "__VITE_ASSET__Cm6lcq4l__"